import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 79 141" {...props}><path fill="currentColor" stroke="currentColor" d="M76.2 64.7c3.1 3.2 3.1 8.4 0 11.6l-61.8 61.8C7 145.6-4.7 134 2.8 126.5l56-56-56-56C-4.7 7 7-4.6 14.5 2.9l61.7 61.8z" /></svg>);